module.exports = __webpack_public_path__ + "img/standard-screen.b35f91ac.svg";